export enum LocalhostKeys {
    THEME_COLOR = 'THEME_COLOR',
    SIDEBAR_FILL_COLOR = 'SIDEBAR_FILL_COLOR',
    BACKGROUND_IMAGE = 'BACKGROUND_IMAGE',
    SIDEBAR_STYLE = 'SIDEBAR_STYLE',
    THEME = 'THEME',
    MODE = 'MODE',
    USERNAME = "USERNAME",
    SESSION = "SESSION"
}